<template>
  <div>
    <div class="tm-order-header uk-margin-small 2">
      <div class="uk-grid uk-grid-small tm-grid-mob-xsmall uk-flex-middle" data-uk-grid :class="role">
        <!--заказ-->
        <div class="tm-order-count-box uk-width-expand">
          <div class="uk-text-truncate uk-text-center tm-order-count uk-box-shadow-medium uk-position-relative uk-overflow-hidden" @click="copyOrderNumber" :data-uk-tooltip="local_page_keys.order_number_copied_tooltip + ' #2212' + order_number" style="cursor: pointer;display: block;">
            #2212{{ order_number }}
            <!--добавляем класс uk-transition-fade чтобы блок скрывался, при каждом клике на иконку копирования класс uk-transition-fade (если он есть) удаляем и добавляем-->
            <div class="tm-background-green uk-light uk-position-cover " :class="(!copiedOrderNumber? ' uk-transition-fade ' : '')">
              <md-icon class="uk-light">done</md-icon> {{ local_page_keys.order_number_copied }}
            </div>
          </div>
        </div>

        <div v-if="isEducation">
          <div class="tm-button-education tm-order-count uk-box-shadow-medium" :data-uk-tooltip="local_page_keys.button_edu_tooltip">
            {{ local_page_keys.button_edu }}
          </div>
        </div>

        <!--иконка face скрыто по RA-365 -->
        <div v-if="false" class="tm-header-icon-hover">
          <div
              class="uk-button uk-button-default uk-box-shadow-medium"
              style="border-radius: 5px;"
              @click="showDialog10 = true"
              @mousemove="visibleOn()"
              @mouseleave="visibleOff()">
            <img class="" src="/img/icons/Users_group.svg" width="30" height="30" alt="">
          </div>
        </div>

        <!--бонусы для про-ретушеров-->
        <div class="uk-text-right tm-order-count-box uk-position-relative uk-width-auto">
          <template v-if="role == 'pro-retoucher' && like">
            <div class="tm-rating-star-animation">
              <md-icon>star</md-icon>
              <div class="tm-rating-star-animation-text">{{ like }}</div>
            </div>
          </template>
          <div class="tm-order-count uk-box-shadow-medium">
            <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
              <div>
                +{{ bonusNow && bonusNow > 0 ? bonusNow : 0 }}%
                <span class="tm-pro-rating" v-if="bonusData && role == 'pro-retoucher'">
                  (#{{ bonusData.place ? bonusData.place : '' }}{{ bonusData.place && [1, 2, 3].includes(bonusData.place) ? "🏆" : "" }})
                </span>
              </div>
              <div class="uk-dropdown tm-dropdown tm-dropdown-left-top"
                   style="width:300px"
                   data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-top; delay-hide: 0; delay-show: 0; offset: 10">
                {{local_page_keys.bonus_description_retoucher}}
              </div>
              <RatingDialog
                :dialogClass="'tm-dropdown-bottom-right'"
                :dialogPosition="'bottom-right'"
                :dialogOffset="'10'"
                v-if="role == 'pro-retoucher'"
                :bonus-data="bonusData"/>
              <div v-if="bonusNow>bonusOld">
                <span class="uk-text-success">▲</span>
              </div>
              <div v-if="bonusNow<bonusOld">
                <span class="uk-text-danger">▼</span>
              </div>
            </div>
          </div>
        </div>

        <!--кол-во заказов для ретушера-->
        <CountNewOrders
          :role="role"
          :local_page_keys="local_page_keys"
          :downtime="computedDowntime"/>

        <!--кол-во проверенных заказов для сеньера-->
        <OrdersStatSenior
          :role="role"
          :local_page_keys="local_page_keys"/>

        <!--переключатель авто перехода к новому заказа для про-ретушера-->
        <div v-if="role == 'pro-retoucher'" class="uk-margin-auto">
          <CountNewOrdersPro
            :role="role"
            :new_orders_count="children_new_orders_count"
            :education="isEducation"
            :local_page_keys="local_page_keys"/>
        </div>
        <div v-if="['pro-retoucher', 'retoucher', 'junior-retoucher'].indexOf(role) > -1" class="uk-width-auto tm-order-auto-box" :class="{ 'uk-disabled tm-disabled': computed_auto_order_check_unclick, 'error': '' }">
          <div v-show="isEducation != 1" class="tm-order-auto">
            <div class="tm-checkbox1">
              <div>
                <!--автопереход по всем заказам-->
                <input type="radio" id="auto_order_check1" name="item1" value="1" checked v-model="auto_order_check">
                <label :for=" role === 'retoucher' ? 'auto_order_check2' : 'auto_order_check3' "
                       class="toggleWrapper1 tm-light">
                  <md-icon>autorenew</md-icon>
                </label>
                <!--автопереход по своим заказам-->
                <template v-if="role === 'retoucher'">
                  <input type="radio" id="auto_order_check2" name="item1" value="2" v-model="auto_order_check">
                  <label for="auto_order_check3" class="toggleWrapper1">
                    <md-icon class="tm-light">autorenew</md-icon>
                  </label>
                </template>
                <!--автопереход выключен-->
                <input type="radio" id="auto_order_check3" name="item1" value="0" v-model="auto_order_check">
                <label for="auto_order_check1" class="toggleWrapper1">
                  <md-icon class="tm-light">autorenew</md-icon>
                </label>
              </div>
              <!--выпадающие окно с описанием-->
              <div class="uk-dropdown tm-dropdown tm-dropdown-left-top uk-padding-remove" data-uk-dropdown="pos: left-top; offset: 15;" style="width:360px;">
                <div class="uk-grid uk-grid-collapse uk-child-width-1-1 tm-menu-dropdown uk-position-relative uk-position-z-index" data-uk-grid>
                  <div :class="{'tm-active': auto_order_check === 1 }" @click="toggleOrderCheckChange(1)">
                    <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                      <div class="uk-width-auto">
                        <div class="toggleWrapper2 " style="background-color: rgba(76, 175, 80, 1);">
                          <md-icon>autorenew</md-icon>
                        </div>
                      </div>
                      <div class="uk-width-expand">{{ local_page_keys.auto_order_check_mode_all }}</div>
                    </div>
                  </div>
                  <!--видно только ретушеру-->
                  <div v-if="role === 'retoucher'" :class="{'tm-active': auto_order_check === 2 }" @click="toggleOrderCheckChange(2)">
                    <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                      <div class="uk-width-auto">
                        <div class="toggleWrapper2" style="background-color: rgba(76, 175, 80, 0.5)">
                          <md-icon>autorenew</md-icon>
                        </div>
                      </div>
                      <div class="uk-width-expand">{{ local_page_keys.auto_order_check_mode_only_directed }}</div>
                    </div>
                  </div>
                  <div :class="{'tm-active': auto_order_check === 0 }" @click="toggleOrderCheckChange(0)">
                    <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
                      <div class="uk-width-auto">
                        <div class="toggleWrapper2">
                          <md-icon>autorenew</md-icon>
                        </div>
                      </div>
                      <div class="uk-width-expand">{{ local_page_keys.auto_order_check_mode_off }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--диалоговое окно - главное фото до with faces-->
    <md-dialog
        class="tm-gal-dialog"
        :md-active.sync="showDialog10"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog10 = false">
          <span class="material-icons">close</span>
        </a>

        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <img class="alter-photo"
               v-if="main_photo_before_with_faces !== null"
               :src="main_photo_before_with_faces" alt="">
          <img class="alter-photo" v-else src="/img/images.png" alt="">
        </div>

      </div>
    </md-dialog>
  </div>
</template>

<script>
import CountNewOrders from "@/pages/Dashboard/Components/CountNewOrders";
import CountNewOrdersPro from "@/pages/Dashboard/Components/CountNewOrdersPro";
import OrdersStatSenior from "./OrdersStatSenior.vue";
import RatingDialog from "./Dialogs/RatingDialog.vue";

export default {
  name: "OrderCardHead",
  props: {
    order_number: {
      type: String,
      require: true
    },
    new_orders_count: {
      type: Number,
    },
    education: {
      type: Number,
    },
    main_photo_before_with_faces: {
      type: String,
      require: true
    },
    role: {
      type: String,
      require: true,
    },
    downtime: {
      type: Object,
      //require: true,
    },
  },
  data: () => ({
    auto_order_check: 1,
    showDialog10: false,
    local_page_keys: {},
    withFacesVisible: false,
    countneworders: null,
    bonusNow: null,
    bonusOld: null,
    bonusData: {},
    like: null,
    orderPagePathName:'/new_mvp/order-func-based',
    user:'',
    auto_order_check_unclick: false,
    copiedOrderNumber: false,
  }),
  components: {
    RatingDialog,
    OrdersStatSenior,
    CountNewOrders,
    CountNewOrdersPro,
  },
  watch: {
    auto_order_check(newValue) {
      this.autoOrderCheckChange();
    },
  },
  computed: {
    children_new_orders_count() {
      return this.new_orders_count;
    },
    isEducation() {
      return this.education;
    },
    computedDowntime() {
      return this.downtime;
    },
    computed_auto_order_check_unclick(){
      return this.auto_order_check_unclick;
    }
  },
  methods: {
    copyOrderNumber(){
        this.copiedOrderNumber = true;
        let _this = this;
        const input = document.createElement('input');
        input.value = '2212'+ this.order_number ;
        document.body.appendChild(input);
        input.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(input);
        setTimeout(function(){
          _this.copiedOrderNumber = false;
        }, 400);

    },
    autoOrderCheckChange() {
      this.$emit('auto_order_check', new Number(this.auto_order_check));
    },
    toggleOrderCheckChange(mode) {
      this.auto_order_check = mode;
    },
    visibleOn() {
      this.$emit('visible', this.withFacesVisible = true);
      this.$emit('visible-after', false);
    },
    visibleOff() {
      this.$emit('visible', this.withFacesVisible = false);
      this.$emit('visible-after', true);
    },
    async setBonusData() {
      await this.$store.dispatch('users/getWeekBonusData');

      let weekBonusData = await this.$store.getters['users/weekBonusData'];
      this.bonusNow = weekBonusData.now ?? null;
      this.bonusOld = weekBonusData.old ?? null;
      this.bonusData = weekBonusData;
      if (this.bonusData && this.bonusData.like) {
        this.like = this.bonusData.like;
        setTimeout(fn => {
          this.like = null;
        }, 10000);
      } else {
        this.like = null;
      }
    },
    enableAutoOrder(data) {
      if (!data['enable_auto_order_check']) {
        this.auto_order_check = 0;
        // const radioInputs = document.querySelectorAll('.tm-checkbox1 input[type="radio"]');
        // radioInputs.forEach(input => {
        //   input.disabled = true;
        // });
      }
    },
    async enableAutoOrderCheckOrderPagePath() {
      this.user = await this.$store.getters['profile/me'](this.getterKey);
      this.$nextTick(function () {
        if (window.location.pathname === this.orderPagePathName && ('order_page' in this.user && this.user.order_page === 2)) {
          this.auto_order_check = 0;
          this.auto_order_check_unclick = true;
        }
      });
    }
  },
  async created() {
    this.autoOrderCheckChange();
    this.local_page_keys = await this.$filtergetLocalisationPage('order');
    this.local_page_keys = Object.assign(
        {},
        await this.$filtergetLocalisationPage('order'),
        await this.$filtergetLocalisationPage('order-downtime'),
        await this.$filtergetLocalisationPage('order-orderCheck')
    );

    if (this.role !== 'admin') {
      await this.setBonusData();
      // setInterval(() => {
      //   if(JSON.parse(sessionStorage.getItem('notDuplicateTabCheck') || 'false')){
      //     this.setBonusData();
      //   }
      // }, 30000);
    }

    // if(!this.role || this.role == ''){
    //   this.role = await this.$store.getters['profile/role'];
    // }
    //turn off enableAutoOrderCheckOrderPagePath functional
    //this.enableAutoOrderCheckOrderPagePath();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isEducation == 1) {
          this.auto_order_check = 0;
        }
      }, 2000);

    });

  }
}
</script>
<style>
.tm-rating-star-animation-text {
  position: absolute;
  top: 50%;
  left: 50%;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  transform: translate(-50%, -50%);
}

.tm-rating-star-animation .md-icon {
  color: #ffaa44 !important;
  font-size: 40px !important;
  line-height: 40px;
  width: 40px;
  min-width: 40px;
  height: 40px;
}

.tm-rating-star-animation {
  display: block;
  position: absolute;
  top: -20px;
  left: -4px;
  animation: slide-in-elliptic-top-fwd 10s cubic-bezier(0.175, 0.885, 0.32, 1) both;
}

@keyframes slide-in-elliptic-top-fwd {
  0% {
    transform: translateY(-100px) rotateX(60deg) scale(0);
    transform-origin: 50% 100%;
    opacity: 0;
  }
  20% {
    transform: translateY(0) rotateX(0) scale(1);
    transform-origin: 50% 200px;
    opacity: 1;
  }
  90% {
    transform: translateY(0) rotateX(0) scale(1);
    opacity: 1;
  }
  to {
    transform: translateY(-30px) scale(2);
    opacity: 0;
  }
}
.tm-disabled{
  pointer-events: none;
}
</style>
